import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";
import Sparkle from "@/components/Sparkle";
import TextButton from "@/components/TextButton";

const SMS_LINK =
  "sms:+12109204677?&body=Hi%20Shaken%20Society!%20I%27d%20like%20to%20know%20more%20about%20your%20mobile%20bar%20service.";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="grain bg-espresso-deep px-5 pb-10 pt-20 sm:px-8">
      <TextButton />
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-12 lg:flex-row">
          <div>
            <img src="/logo-glass.png" alt="Shaken Society coupe glass" className="w-40" data-testid="footer-logo" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-cream/55">
              Dry hire mobile bar service. Bartenders, mixers, garnish, glassware and
              signature cocktails — served with a shake of theatre.
            </p>
          </div>

          <div className="flex gap-16 sm:gap-24">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">Visit</p>
              <ul className="mt-5 space-y-3 text-sm text-cream/70">
                <li>La Cantera — Boerne area</li>
                <li className="text-[11px] tracking-wide text-cream/40">Events outside a 30-mile radius are subject to an upcharge</li>
                <li>
                  <a
                    href="tel:+12109204677"
                    data-testid="footer-phone-link"
                    className="transition-colors hover:text-gold"
                  >
                    (210) 920-4677
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:Jasmine@shakensociety.com"
                    data-testid="footer-email-link"
                    className="transition-colors hover:text-gold"
                  >
                    Jasmine@shakensociety.com
                  </a>
                </li>
                <li>By appointment</li>
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">Explore</p>
              <ul className="mt-5 space-y-3 text-sm text-cream/70">
                {[
                  { id: "packages", label: "Packages" },
                  { id: "gallery", label: "Gallery" },
                  { id: "reviews", label: "Reviews" },
                  { id: "faq", label: "FAQ" },
                  { id: "book", label: "Book your date" },
                ].map((l) => (
                  <li key={l.id}>
                    <button
                      data-testid={`footer-link-${l.id}`}
                      onClick={() => document.getElementById(l.id)?.scrollIntoView({ behavior: "smooth" })}
                      className="transition-colors hover:text-gold"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-cream/10 pt-8">
          <p className="font-display text-[13vw] leading-none text-cream/[0.07] sm:text-7xl lg:text-8xl" data-testid="footer-wordmark">
            Shaken Society
          </p>
          <div className="mt-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <p className="flex items-center gap-2 text-xs text-cream/40">
              © {new Date().getFullYear()} Shaken Society
              <Sparkle className="h-3 w-3 text-gold" />
              Dry hire mobile bar · San Antonio, TX
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href={SMS_LINK}
                data-testid="footer-text-link"
                className="flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-semibold text-espresso transition-all duration-300 hover:scale-105 hover:bg-cream"
              >
                <MessageCircle className="h-4 w-4" />
                Text us
              </a>
              <a
                href="https://www.instagram.com/TheShakenSociety"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Shaken Society on Instagram"
                data-testid="footer-instagram-link"
                className="flex items-center gap-2 rounded-full border border-cream/15 px-5 py-2.5 text-sm text-cream/70 transition-all duration-300 hover:border-gold hover:text-gold"
              >
                <Instagram className="h-4 w-4" />
                @TheShakenSociety
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}